var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12.5 0C5.596 0 0 5.596 0 12.5S5.596 25 12.5 25 25 19.404 25 12.5 19.404 0 12.5 0zm0 4a8.5 8.5 0 110 17 8.5 8.5 0 010-17z","fill":"#FFC10D","fill-rule":"nonzero"}})
}
var staticRenderFns = []

export { render, staticRenderFns }